import React, { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  Select,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Flex,
  useToast,
  Text,
} from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';
import { useParams, useNavigate } from 'react-router-dom';

// MESA EXAMINADORA (Módulo 7).
// Requerimiento cliente:
//   - Poder asignar una mesa examinadora (tribunal) a un examen individual.
//   - Un examen puede tener N docentes en la mesa (presidente, vocales, etc.).
//
// TODO backend:
//   - Endpoint GET  /exam/schedule/:id/tribunal  -> lista docentes asignados.
//   - Endpoint POST /exam/schedule/:id/tribunal  -> asignar docente
//       body: { employeeId, role? }
//   - Endpoint DELETE /exam/schedule/:id/tribunal/:employeeId -> desasignar.
//   - Validar que el docente esté activo (employee.enabled = 1).
//
// NOTA: esta vista es un STUB. No persiste cambios hasta que se implementen
// los endpoints; muestra los datos en memoria y un aviso al guardar.

export default function ExamTribunalView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  const [availableTeachers, setAvailableTeachers] = useState([]);
  const [assigned, setAssigned] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState('');

  useEffect(() => {
    // TODO backend: GET /employees?role=teacher&enabled=1
    setAvailableTeachers([
      { id: 1, fullName: 'Docente ejemplo 1' },
      { id: 2, fullName: 'Docente ejemplo 2' },
    ]);
    // TODO backend: GET /exam/schedule/:id/tribunal
    setAssigned([]);
  }, [id]);

  const handleAssign = () => {
    if (!selectedTeacher) return;
    const teacher = availableTeachers.find(
      (t) => String(t.id) === String(selectedTeacher),
    );
    if (!teacher) return;
    if (assigned.some((t) => t.id === teacher.id)) {
      toast({
        title: 'Docente ya asignado',
        status: 'warning',
        duration: 2500,
      });
      return;
    }
    setAssigned((prev) => [...prev, teacher]);
    setSelectedTeacher('');
  };

  const handleRemove = (teacherId) => {
    setAssigned((prev) => prev.filter((t) => t.id !== teacherId));
  };

  const handleSave = () => {
    // TODO backend: persistir assigned vía POST /exam/schedule/:id/tribunal.
    toast({
      title: 'Mesa examinadora pendiente de persistencia',
      description:
        'Falta implementar el endpoint POST /exam/schedule/:id/tribunal.',
      status: 'info',
      duration: 4000,
      isClosable: true,
    });
  };

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Flex justify="space-between" align="center" mb={4}>
        <Heading size="md">Mesa examinadora del examen #{id}</Heading>
        <Button variant="outline" onClick={() => navigate(-1)}>
          Volver
        </Button>
      </Flex>

      <Flex gap={2} mb={4} align="center">
        <Select
          placeholder="Seleccionar docente"
          value={selectedTeacher}
          onChange={(e) => setSelectedTeacher(e.target.value)}
          maxW="320px"
        >
          {availableTeachers.map((t) => (
            <option key={t.id} value={t.id}>
              {t.fullName}
            </option>
          ))}
        </Select>
        <Button colorScheme="teal" onClick={handleAssign}>
          Asignar
        </Button>
      </Flex>

      {assigned.length === 0 ? (
        <Text color="gray.500">No hay docentes asignados al tribunal.</Text>
      ) : (
        <Table size="sm" variant="simple">
          <Thead>
            <Tr>
              <Th>Docente</Th>
              <Th w="80px">Quitar</Th>
            </Tr>
          </Thead>
          <Tbody>
            {assigned.map((t) => (
              <Tr key={t.id}>
                <Td>{t.fullName}</Td>
                <Td>
                  <IconButton
                    aria-label="Quitar"
                    icon={<DeleteIcon />}
                    size="sm"
                    variant="ghost"
                    colorScheme="red"
                    onClick={() => handleRemove(t.id)}
                  />
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}

      <Flex justify="flex-end" mt={4}>
        <Button colorScheme="blue" onClick={handleSave}>
          Guardar mesa
        </Button>
      </Flex>
    </Box>
  );
}
